export default {"src":"/_next/static/media/WhoWeAre_038A.2d831cf0.JPG","height":702,"width":1920};